<template>
  <page-table />
</template>
<script>
import PageTable from './components/plan-order-table'
export default {
  name: 'plan-planOrder',
  components: {
    PageTable,
  },
}
</script>